export default {
  "content": "<path d=\"M20 0L2 4.5V4H0v6h2v-.5l2 .5v1c0 1.65 1.35 3 3 3a2.99 2.99 0 002.95-2.51L20 14V0zM7 12c-.55 0-1-.45-1-1v-.5l2 .5c0 .55-.45 1-1 1zm11-.56l-16-4v-.88l16-4v8.88z\" fill=\"#000\" fill-opacity=\".9\"/>",
  "attrs": {
    "width": "20",
    "height": "14",
    "viewBox": "0 0 20 14",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};